import { useState, useEffect } from 'react';

/**
 * Je okno dost široké, aby se vyplatilo zamrazit celý levý blok tabulky?
 *
 * AOP vrstvy mrazí 400–708 px sloupců. Na notebooku (1280–1440 px) by na
 * dvanáct měsíců zbylo pár set pixelů, takže pod prahem mrazíme jen název.
 */
export default function useSirokyDisplej(prah = 1400) {
    const [siroky, setSiroky] = useState(
        () => typeof window !== 'undefined' && window.innerWidth >= prah
    );

    useEffect(() => {
        const mq = window.matchMedia(`(min-width: ${prah}px)`);
        const zmena = (e) => setSiroky(e.matches);
        setSiroky(mq.matches);
        mq.addEventListener('change', zmena);
        return () => mq.removeEventListener('change', zmena);
    }, [prah]);

    return siroky;
}
